import { Metadata_Service } from '.';
import { GetSparkConfigRequest, GetSparkConfigResponse } from '../types/tecton_proto/metadataservice/metadata_service';

export const fetchGetSparkConfig = async (payload: GetSparkConfigRequest): Promise<GetSparkConfigResponse> => {
  const response = await Metadata_Service.post('get-spark-config', payload);
  return response.data;
};
